import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import AttachmentTab from '../attachment/AttachmentTab';

export default function EquipmentFiles({ equipmentId }) {
  const equipmentFiles = useSelector((state) => state.equipment.equipmentFiles);
  const {
    [equipmentId]: files = [],
  } = equipmentFiles;

  const attachments = useMemo(() => ({
    instantiatedFiles: files,
    locationMap: {},
  }), [files]);

  return <AttachmentTab attachments={attachments} />;
}

EquipmentFiles.propTypes = {
  equipmentId: PropTypes.string,
};

EquipmentFiles.defaultProps = {
  equipmentId: undefined,
};
